import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"user",
    list_id:"book_order_use_list",
    x_column_list_arr:[
      {"key":"a_user_name","name":"이름","width":"7","is_show":"1"},
      {"key":"a_user_id","name":"아이디","width":"5","is_show":"1"},
      {"key":"row_view_class_name","name":"클래스","width":"10","is_show":"1"},
      {"key":"row_view_new_order","name":"신규주문","width":"4","is_show":"1"},
      {"key":"row_view_order_manage","name":"교재주문","width":"60","is_show":"1"},
      // {"key":"row_view_class_status","name":"수강상태","width":"110","is_show":"1"},
      // {"key":"row_view_class_package","name":"패키지","width":"110","is_show":"1"},
      // {"key":"row_view_now_grade","name":"현재단계","width":"110","is_show":"1"},
      // {"key":"row_view_period","name":"학습기간","width":"200","is_show":"1"},
      // {"key":"row_view_remain_day","name":"잔여일","width":"90","is_show":"1"},
      // {"key":"row_view_order_manage","name":"신청","width":"110","is_show":"1"},
      // {"key":"row_view_order_inout","name":"추가/취소","width":"110","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':100,
      'order_id':'',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
      "is_add_idx_info":"1",
      "s_class_seq":"",
      "s_school_name":"",
      "s_stu_grade":"",
      "s_stu_state":"now",
      "s_is_par_join":"",
      "s_search_text_type":"name",
      "s_search_text":"",
      "s_user_name_like":"",
      "s_phone_like":"",
      "s_stu_num_like":"",
      "s_school_name_like":"",
      "s_class_name_like":"",
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);
  xColumnArr.date_col_arr=["a_join_date"];

  return xColumnArr;
};

export default getXcolumnJson;